import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Product } from '~/Api/Product';
import { Action, fetchProductIfNeeded, selectProductById } from '~/Product';
import { State, ThunkDispatch } from '~/Store';

export const ProductProvider: React.FunctionComponent<
	React.PropsWithChildren<{
		id: string;
		children(product: Product | null): React.ReactNode;
	}>
> = ({ id, children }) => {
	const dispatch: ThunkDispatch<Action> = useDispatch();
	React.useEffect(() => {
		dispatch(fetchProductIfNeeded(id));
	}, [id]);

	const product = useSelector((state: State) => selectProductById(state.products, id));

	return <>{children(product || null)}</>;
};

ProductProvider.displayName = 'Product.ProductProvider';
